import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';

export default function ({ openUrl, urlError, url, openUrlOutsideApp, openAlertDialog, confirmButtonName, onChangeField, onClickCheckBox }) {
	return (
		<React.Fragment>
			<FormControlLabel
				control={<Checkbox
					color="primary"
					checked={openUrl}
					onChange={() => onClickCheckBox('openUrl')}
					style={{ block: { maxWidth: 250 }, checkbox: { marginBottom: 16, } }}
				/>}
				label="Abrir URL"
			/>
			<br />
			{openUrl &&
				<React.Fragment>
					<InputLabel shrink >
						URL
					</InputLabel>
					<TextField
						error={urlError !== '' && urlError !== null}
						helperText={urlError}
						value={url}
						onChange={event => onChangeField('url', event.target.value)}
						fullWidth
					/>
					<br />
					<br />
					<FormControlLabel
						control={<Checkbox
							color="primary"
							checked={openUrlOutsideApp}
							onChange={() => onClickCheckBox('openUrlOutsideApp')}
							style={{ block: { maxWidth: 250 }, checkbox: { marginBottom: 16, } }}
						/>}
						label="Abrir URL fora do aplicativo (Somente Mobile)"
					/>
					<br />
					<br />
					<FormControlLabel
						control={<Checkbox			
							color="primary"
							checked={openAlertDialog}
							onChange={() => onClickCheckBox('openAlertDialog')}
							style={{ block: { maxWidth: 250 }, checkbox: { marginBottom: 16, } }}
						/>}
						label="Abrir alerta com o conteúdo antes de abrir a URL"
					/>
					<br />
					<div style={{ fontSize: 14, color: '#f4c400' }}>
						<span>OBS: No caso do web, o alerta sempre vai aparecer</span>
						<br />
						<span>OBS2: Caso o usuário esteja com o aplicativo aberto, o alerta irá aparecer de toda forma</span>
						<br />
					</div>
					<br/>
					<InputLabel shrink >
					Texto do botão de confirmação
					</InputLabel>
					<TextField
						value={confirmButtonName}
						onChange={(event) => onChangeField('confirmButtonName', event.target.value)}
						fullWidth
					/>
					<br />
					<br />
				</React.Fragment>
			}
		</React.Fragment>
	);
}


// WEBPACK FOOTER //
// ./src/components/notification/fields/UrlField.js